import {useQuery} from "react-query";
import {FolderSearchRequest} from "../../models/drive";
import folderService from "../../services/FolderService";

export default function useFolders(request?: FolderSearchRequest) {
   return useQuery(['folders', request], () => folderService.search(request), {
      enabled: !!request?.spaceId
   });
}